import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import {
  Container,
  QuestionLabel,
  Instructions,
  Checkbox,
} from './styles';

const MultipleQuestionType = (props) => {
  const {
    question,
    onQuestionAnswered,
  } = props;

  const [selectedItems, setSelectedItems] = useState({});

  const answerQuestion = (touched = false) => {
    const { id: questionId } = question;

    const errorMessage = 'Please select an answer';

    const showErrorMessage = _.isEmpty(_.filter(selectedItems, (item) => item));

    onQuestionAnswered({
      questionId,
      error: showErrorMessage ? errorMessage : null,
      touched,
    });
  };

  useEffect(() => {
    answerQuestion();
  }, [selectedItems]);

  const handleClickCheckbox = (id) => {
    setSelectedItems({
      ...selectedItems,
      [id]: !selectedItems[id],
    });
  };

  return (
    <Container>
      <QuestionLabel>{question.label}</QuestionLabel>
      {question.questionOptions.map((option) => (
        <Checkbox
          label={option.label}
          onChange={() => handleClickCheckbox(option.id)}
          checked={selectedItems[option.id]}
        />
      ))}
      <Instructions>
        Remember to speak your thoughts aloud.
      </Instructions>
    </Container>
  );
};

MultipleQuestionType.propTypes = {
  question: PropTypes.shape({
    label: PropTypes.string,
    questionOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
    })),
    id: PropTypes.string,
  }).isRequired,
  onQuestionAnswered: PropTypes.func.isRequired,
};

export default MultipleQuestionType;
